import { useState } from 'react'
import { Modal } from './Modal'
import './AppointmentDNAModal.css'

interface AppointmentDNAModalProps {
  appointment: {
    id: string
    patientName: string
    staffName: string
    appointmentDate: string
    startTime: string
    type: string
  }
  isOpen: boolean
  onClose: () => void
  onConfirm: (reason?: string) => Promise<void>
  isLoading?: boolean
}

export function AppointmentDNAModal({
  appointment,
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
}: AppointmentDNAModalProps) {
  const [reason, setReason] = useState('')

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    await onConfirm(reason.trim() || undefined)
    setReason('') // Reset form on success
  }

  const handleClose = () => {
    if (!isLoading) {
      setReason('')
      onClose()
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title="Mark as DNA (Did Not Attend)">
      <form onSubmit={handleSubmit} className="appointment-dna-form">
        <div className="appointment-dna-info">
          <p>
            <strong>Patient:</strong> {appointment.patientName}
          </p>
          <p>
            <strong>Staff:</strong> {appointment.staffName}
          </p>
          <p>
            <strong>Date:</strong> {new Date(appointment.appointmentDate).toLocaleDateString()}
          </p>
          <p>
            <strong>Time:</strong> {appointment.startTime}
          </p>
          <p>
            <strong>Type:</strong> {appointment.type}
          </p>
        </div>

        <div className="form-group">
          <label htmlFor="dna-reason">
            DNA Reason <span className="optional">(optional)</span>
          </label>
          <textarea
            id="dna-reason"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            rows={4}
            placeholder="Enter reason for DNA (e.g., no contact, forgot appointment, etc.)"
            disabled={isLoading}
          />
        </div>

        <div className="dna-warning">
          <p>⚠️ This will mark the appointment as DNA and update the patient's DNA history.</p>
        </div>

        <div className="form-actions">
          <button
            type="button"
            className="btn-secondary"
            onClick={handleClose}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn-warning"
            disabled={isLoading}
          >
            {isLoading ? 'Marking as DNA...' : 'Mark as DNA'}
          </button>
        </div>
      </form>
    </Modal>
  )
}
